import { render, staticRenderFns } from "./CopyrightFooter.vue?vue&type=template&id=7576609e&scoped=true"
import script from "./CopyrightFooter.vue?vue&type=script&lang=ts"
export * from "./CopyrightFooter.vue?vue&type=script&lang=ts"
import style0 from "./CopyrightFooter.vue?vue&type=style&index=0&id=7576609e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7576609e",
  null
  
)

export default component.exports